<template>
	<div class="commercial" ref="focusLost">
		<keep-alive>
			<BlockFiltersModal :data="DataFiltersModal" :filtrationInProgress="filtrationInProgress" :isFilterHidden="renderingInProgress || isFilterHidden"
				@startFiltration="startFiltration" @resetFiltration="resetFiltration" />
		</keep-alive>
		<div class="properties-listing container">
			<div class="properties-listing__tabs">
				<div class="properties-listing__tabs-header">
					<div class="properties-listing__tabs-title">
						<h2 class="section-title section-title--properties-listing" v-if="listView && numOfProperties > 1">
							Showing<span> {{ numOfProperties }}</span> Commercial Properties</h2>
						<h2 class="section-title section-title--properties-listing"
							v-else-if="listView && numOfProperties === 1">Showing <span v-if="numOfProperties">{{
								numOfProperties }}</span> Commercial Property</h2>
						<h2 class="section-title section-title--properties-listing"
							v-else-if="!listView && numOfProperties > 1">Showing total of <span v-if="numOfProperties">{{
								numOfProperties }}</span> Commercial Properties</h2>
						<h2 class="section-title section-title--properties-listing"
							v-else-if="!listView && numOfProperties === 1">Showing total of <span v-if="numOfProperties">{{
								numOfProperties }}</span> Commercial Property</h2>
					</div>
					<div class="properties-listing__tabs-button">
						<button class="btn-tab left-tab-button" :class="{ 'active': listView }" @click="chooseTab(1)">
							<SvgIcon iconName="ico-exclamation-regular"/>
							List View
						</button>
						<button class="btn-tab right-tab-button" :class="{ 'active': !listView }" @click="chooseTab(2)">
							<SvgIcon iconName="ico-map"/>
							Map View
						</button>
						<button v-if="user.role !== 'agent'" class="btn btn--mid btn--icon" @click="exportCSV()">
							Export
						</button>
					</div>
				</div>
				<div class="properties-listing__tabs-content">
					<transition name="fade" appear>
						<div v-show="listView" class="properties-listing__tabs-inner">
							<keep-alive>
								<BlockTable class="extended-table extended-table--new extended-table--commercial" 
									v-if="!noResults" 
									:data="DataTable"
									:flagHide="true" @sortData="sortProperties"
									@PropertyHistoryOrEdit="PropertyHistoryOrEdit" 
									@getPage="getPage" 
									:sort="localOrderBy"
									:order="localOrder === 'desc'" />
								<!-- :sort="localOrderBy"
									:order="localOrder === 'desc'" -->
							</keep-alive>
							<PartLoaderBig class="properties-listing__loader" v-if="preloader" />

							<PartNoResults :data="DataNoResults" v-if="noResults && !preloader" />
							<!-- TODO: add v show and correct handlers -->
							<!-- <PartPagination
								ref="pagination"
								@getPage="getPage"
							/> -->
							<!-- v-show="!preloader && showPagination" -->
						</div>
					</transition>
					<transition name="fade" appear>
						<div v-show="!listView" class="properties-listing__tabs-inner properties-listing__tabs-inner--map">
							<keep-alive>
								<BlockMapInput v-show="!noResults" :data="DataMap" ref="map" :markers="markers" :isFilterHidden="isFilterHidden" :renderingInProgress="renderingInProgress" @toggleRendering="toggleRenderProgress"/>
							</keep-alive>
							<keep-alive>
								<PartNoResults :data="DataNoResults" v-show="noResults" />
							</keep-alive>
						</div>
					</transition>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import BlockFiltersModal from '@/components/blocks/BlockFiltersModal';
import PartNoResults from '@/components/parts/PartNoResults';
import BlockMapInput from '@/components/blocks/BlockMapInput';
import BlockTable from '@/components/blocks/BlockTable';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
// import PartPagination from '@/components/parts/PartPagination';
import { check } from '@/services/RouteGuards/SuperAdmin';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},

	components: {
		BlockFiltersModal,
		PartNoResults,
		BlockMapInput,
		BlockTable,
		PartLoaderBig,
		SvgIcon
		// PartPagination
	},

	data: function () {
		return {
			renderingInProgress: false,
			isFilterHidden: false,
			infinitScrollFlag: false,
			filtrationInProgress: false,
			initialLoad: true,
			sortInProgress: false,
			from: '',
			to: '',
			numOfProperties: '',
			DataNoResults: {},
			PropertiesListingData: {},
			listView: true,
			noResults: true,
			localOrder: 'desc',
			localOrderBy: 'date_listed',
			defaultOrder: 'desc',
			defaultOrderBy: 'date_listed',
			preloader: true,
			markers: [],
			filter: {},
			DataTable: {
				stickyHeader: true,
				noCollapse: false,
				noLocalSorting: true,
				tableClass: 'text-nowrap',
				defaultOrderBy: 'date_listed',
				fields: [
					{ key: 'title', label: 'Name', sortable: true, stickyColumn: true, variant: 'property thead-lg' },
					{ key: 'offering_type_label', label: 'Offering Type', sortable: true, stickyColumn: true, variant: 'listing-status' },
					{ key: 'area', label: 'Area', sortable: true, stickyColumn: true, variant: 'area' },
					{ key: 'property_type', label: 'Type', sortable: true, stickyColumn: true, variant: 'type' },
					{ key: 'building_size', label: 'Building Size', sortable: true, stickyColumn: true, variant: 'building-size' },
					{ key: 'lot_size', label: 'Lot Size', sortable: true, stickyColumn: true, variant: 'lot-size' },
					{ key: 'regular_price', label: 'Price', sortable: true, stickyColumn: true, variant: 'price' },
					{ key: 'price_buildable_sf', label: 'Price per Buildable SF', sortable: true, stickyColumn: true, variant: 'price-buildable-sf' },
					{ key: 'price_psf', label: 'Price per SF', sortable: true, stickyColumn: true, variant: 'price-psf' },
					{ key: 'lease_price', label: 'Lease Price', sortable: true, stickyColumn: true, variant: 'lease-price' },
					{ key: 'yearly_price', label: 'Yearly Price per SF', sortable: true, stickyColumn: true, variant: 'yearly-price' },
					{ key: 'listing_status_label', label: 'Listing Status', sortable: true, stickyColumn: true, variant: 'listing-status' },
					{ key: 'listing_type_label', label: 'Listing Type', sortable: true, stickyColumn: true, variant: 'listing-type' },
					{ key: 'date_listed', label: 'Date Listed', sortable: true, stickyColumn: true, variant: 'date-added' },
					{ key: 'date_verified', label: 'Date Verified', sortable: true, stickyColumn: true, variant: 'date-verified' },
					{ key: 'lead_source', label: 'Source', sortable: true, stickyColumn: true, variant: 'date-source' },
					{ key: 'agent_name', label: 'Agent', sortable: true, stickyColumn: true, variant: 'agent' },
					{ key: 'iconProp', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon first-icon-fixed table-fixed-icon--dark-blue last-icon-fixed' }
				],
				items: []
			},
			DataMap: {},
			DataFiltersModal: {
				isCustomer: false,
				DataListingStatus: {
					label: 'Listing Status:',
					labelId: 'radio-listing-status-label',
					id: 'radio-listing-status-input',
					lists: []
				},
				DataListingType: {
					label: 'Listing Type:',
					labelId: 'radio-listing-type-label',
					id: 'radio-listing-type-input',
					lists: []
				},
				DataDateListed: {
					inputId: 'date_listed-commercial-input',
					labelId: 'date_listed-commercial-label',
					flag: 'date_listed',
					mandatoryFiled: false,
					today: ''
				},
				DataDateVerified: {
					inputId: 'date_verified-commercial-input',
					labelId: 'date_verified-commercial-label',
					flag: 'date_verified',
					mandatoryFiled: false,
					today: ''
				},
				DataInputSearch: {
					inputId: 'commercial-search-input',
					label: 'Search',
					labelId: 'commercial-search-label',
					placeholder: 'Search...',
					searchClass: 'customers-search',
					type: 'text'
				},
				DataOfferingType: {
					label: 'Offering Type',
					labelId: 'offering-type-commercial-label',
					inputId: 'offering-type-commercial-input',
					placeholder: 'Add Type',
					mandatoryFiled: false,
					options: [],
					multiple: true
				},
				DataArea: {
					label: 'Area',
					labelId: 'area-commercial-label',
					inputId: 'area-commercial-input',
					mandatoryFiled: false,
					placeholder: 'Add Area',
					options: [],
					multiple: true
				},
				DataPropertyType: {
					label: 'Property Type',
					labelId: 'type-commercial-label',
					inputId: 'type-commercial-input',
					placeholder: 'Add Type',
					mandatoryFiled: false,
					options: [],
					multiple: true
				},
				DataAssignedAgent: {
					label: 'Assigned Agent',
					labelId: 'user-commercial-label',
					inputId: 'user-commercial-input',
					placeholder: 'Add Agent',
					mandatoryFiled: false,
					options: [],
					multiple: true
				},
				DataBuildingSize: {
					labelId: 'building-size-commercial-label',
					inputIdMin: 'building-size-commercial-input-min',
					inputIdMax: 'building-size-commercial-input-max',
					label: 'Building Size',
					iconName: 'ico-building',
					classIcon: 'input-icon-box input-icon-box--big',
					flag: 'building_size'
				},
				DataLotSize: {
					labelId: 'lot-size-commercial-label',
					inputIdMin: 'lot-size-commercial-input-min',
					inputIdMax: 'lot-size-commercial-input-max',
					label: 'Lot Size',
					iconName: 'ico-buildings',
					classIcon: 'input-icon-box input-icon-box--big',
					flag: 'lot_size'
				},
				DataPrice: {
					labelId: 'price-commercial-label',
					inputIdMin: 'price-commercial-input-min',
					inputIdMax: 'price-commercial-input-max',
					label: 'Price',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					flag: 'price',
					currency: true
				},
				DataPriceBuildableSquareFoot: {
					labelId: 'price-buildable-sf-commercial-label',
					inputIdMin: 'price-buildable-sf-commercial-input-min',
					inputIdMax: 'price-buildable-sf-commercial-input-max',
					label: 'Price per Buildable Square Foot',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					flag: 'price_buildable_sf',
					currency: true
				},
				DataPriceSquareFoot: {
					labelId: 'price-per-sf-commercial-label',
					inputIdMin: 'price-per-sf-commercial-input-min',
					inputIdMax: 'price-per-sf-commercial-input-max',
					label: 'Price per Square Foot',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					flag: 'price_psf',
					currency: true
				},
				DataLeasePrice: {
					labelId: 'lease_price-commercial-label',
					inputIdMin: 'lease_price-commercial-input-min',
					inputIdMax: 'lease_price-commercial-input-max',
					label: 'Lease Price',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					flag: 'lease_price',
					currency: true
				},
				DataYearlyPrice: {
					label: 'Yearly Price per Square Foot',
					classinput: '',
					inputIdMin: 'yearly_price-commercial-input-min',
					inputIdMax: 'yearly_price-commercial-input-max',
					labelId: 'yearly_price-customer-label',
					iconName: 'ico-dollar-sign',
					classIcon: 'input-icon-box',
					currency: true,
					flag: 'yearly_price'
				},
				DataNeighborhood: {
					type: 'text',
					inputId: 'neighborhood-input',
					placeholder: 'Neighborhood',
					label: 'Neighborhood',
					labelId: 'neighborhood-label',
					searchClass: 'customers-search'
				},
				DataSource: {
					type: 'text',
					inputId: 'lead_source-input',
					placeholder: 'Lead Source',
					label: 'Lead Source',
					labelId: 'lead_source-label',
					searchClass: 'customers-search'
				}
			}
		};
	},
	created() {
		const user = JSON.parse(localStorage.getItem('user'));
		if (localStorage.getItem('filter-property') && JSON.parse(localStorage.getItem('filter-property')).user_id === user.id) {
			this.filter = JSON.parse(localStorage.getItem('filter-property')).filter;
			this.startFiltration(this.filter);
		}
	},
	mounted() {
		this.initDropDowns();
		this.getPage();
		this.$store.dispatch('getAssigned').then((res) => {
			this.DataFiltersModal.DataAssignedAgent.options = res.data;
		});

		if (!this.checkPermissions()) {
			this.DataTable.fields.forEach((el, index) => {
				if (el.key === 'agent_name') {
					this.DataTable.fields.splice(index, 1);
				}
			});
		}
	},
	computed: {
		properties() {
			return this.$store.getters.getCommercialProperties;
		},
		propertiesInfinitResult() {
			return this.$store.getters.getPropertiesInfinitResult;
		},
		user() {
			return this.$store.getters.getUser;
		}
	},
	watch: {
		properties() {
			this.noResults = !this.properties.length;
			this.preloader = false;
			const arr = [];
			this.properties.forEach((ele) => {
				if (ele.listing_status_label === 'In Contract') {
					ele._rowVariant = 'in-contract';
				}
				arr.push(ele);
			});
			this.DataTable.items = arr;
		}
	},
	methods: {
		formatHeader(header) {
			return header
				.split('_')
				.map(word => word.charAt(0).toUpperCase() + word.slice(1))
				.join(' ');
		},
		exportCSV() {
			const dateColumns = ['created_at', 'updated_at', 'date_verified', 'created_at', 'deleted_at'];
			const reqObj = {
				filter: this.filter,
				order_by: this.localOrderBy.replace('_label', ''),
				order: this.localOrder,
				page: 'csv',
				category: 2,
				isFilter: true
			};
			this.$store.dispatch('fetchCommercialProperties', reqObj).then((res) => {
				res.data.properties.forEach((property, index) => {
					Object.keys(property).forEach(key => {
						if (key.includes('date_') || dateColumns.includes(key)) {
							property[key] = property[key] ? property[key].split('T')[0] : '';
						}
					});
					let areaLabel = property.area_label;
					if (areaLabel.includes('Near Brooklyn')) {
						areaLabel = areaLabel.filter(label => label.trim() !== 'Near Brooklyn');
						areaLabel.push('New Jersey');
					}
					if (areaLabel.includes('Near Boro Park')) {
						areaLabel = areaLabel.filter(label => label.trim() !== 'Near Boro Park');
						areaLabel.push('Brooklyn');
					}
					property.area_label = areaLabel;

					property.property_type_label.forEach((label, i) => {
						if (label.search('Comunity') > -1) {
							label = label.replace('Comunity', 'Community');
							property.property_type_label[i] = label;
						}
					});
				});
				if (!res.data.properties.length) return;
				const data = res.data.properties;
				const replacer = (key, value) => {
					if (Array.isArray(value)) return value.join(', ');
					return value === null || value === undefined ? '' : value;
				};

				const allKeys = Object.keys(data[0]);
				const headers = allKeys.filter(key => !key.endsWith('_label'));
				const formattedHeaders = headers.map(this.formatHeader);
				const csv = [
					formattedHeaders.join(','),
					...data.map(row =>
						headers.map(field =>
							JSON.stringify(replacer(field, row[field]))
						).join(',')
					)
				].join('\n');

				const blob = new Blob([csv], { type: 'text/csv' });
				const url = URL.createObjectURL(blob);
				const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
				const filename = `export-${timestamp}.csv`;

				const a = document.createElement('a');
				a.href = url;
				a.download = filename;
				a.style.display = 'none';

				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				URL.revokeObjectURL(url);
			});
		},
		toggleRenderProgress(inProgress) {
			this.renderingInProgress = inProgress;
		},
		// Single property only for published properties
		PropertyHistoryOrEdit(id, target) {
			const routePropertyHistoryOrEdit = this.$router.resolve({ name: 'SinglePropertyAgent', params: { id: id } });
			window.open(routePropertyHistoryOrEdit.href, target);
		},
		chooseTab(num) {
			const obj = {
				category: 2,
				filter: this.filter
			};
			this.listView = num === 1;
			if (!this.listView) {
				this.$store.dispatch('fetchMapMarkers', obj).then((res) => {
					const markers = res.data.map(x => JSON.parse(x.map));
					const properties = res.data.map(x => { return { id: x.id, title: x.title }; });
					this.numOfProperties = properties.length || 0;
					if (markers.length) {
						this.$refs.map.renderAllCommercialProperties(markers, properties);
						this.noResults = false;
					} else {
						this.noResults = true;
					}
				});
				this.preloader = false;
				this.isFilterHidden = false;
			} else {
				if (this.sortInProgress) return;
				const obj = {
					order_by: this.localOrderBy.replace('_label', ''),
					order: this.localOrder,
					category: 2,
					filter: this.filter,
					isFilter: true,
					page: 1
				};

				this.preloader = true;
				this.$store.dispatch('fetchCommercialProperties', obj).then(response => {
					this.numOfProperties = response.data.total;
					response.data.properties.forEach(property => {
						if (property.area_label.includes('Near Boro Park')) {
							property.area_label = ['Brooklyn'];
						}

						if (property.area_label.includes('Near Brooklyn')) {
							property.area_label = ['New Jersey'];
						}

						property.property_type_label.forEach((label, i) => {
							if (label.search('Comunity') > -1) {
								label = label.replace('Comunity', 'Community');
								property.property_type_label[i] = label;
							}
						});
						this.preloader = false;
						this.isFilterHidden = false;
					});
					this.initialLoad = false;
				});
			};
		},
		fetchNewActiveProperties(obj) {
			this.preloader = true;
			return this.$store.dispatch('fetchCommercialProperties', obj);
		},
		getPage() {
			if (this.sortInProgress) return;
			const nextPage = this.initialLoad ? 1 : this.propertiesInfinitResult.current_page === 0 ? 1 : ++this.propertiesInfinitResult.current_page;
			if (this.infinitScrollFlag || nextPage > this.propertiesInfinitResult.last_page) {
				return false;
			}

			const obj = {
				order_by: this.localOrderBy.replace('_label', ''),
				order: this.localOrder,
				category: 2,
				filter: this.filter,
				isFilter: this.initialLoad
			};

			this.infinitScrollFlag = true;
			this.preloader = true;
			this.$store.dispatch('fetchCommercialProperties', { ...obj, page: nextPage }).then(response => {
				this.numOfProperties = response.data.total;
				response.data.properties.forEach(property => {
					if (property.area_label.includes('Near Boro Park')) {
						property.area_label = ['Brooklyn'];
					}

					if (property.area_label.includes('Near Brooklyn')) {
						property.area_label = ['New Jersey'];
					}

					property.property_type_label.forEach((label, i) => {
						if (label.search('Comunity') > -1) {
							label = label.replace('Comunity', 'Community');
							property.property_type_label[i] = label;
						}
					});
					this.preloader = false;
				});
				this.infinitScrollFlag = false;
				this.initialLoad = false;
			});
		},
		sortProperties(item) {
			this.sortInProgress = true;
			this.DataTable.items = [];
			const obj = {
				order_by: item.replace('_label', ''),
				order: this.SortOrder(item),
				page: 1,
				category: 2,
				filter: this.filter,
				isFilter: true
			};
			this.localOrderBy = item;
			this.fetchNewActiveProperties(obj).then(response => {
				this.numOfProperties = response.data.total_commercials;
				this.numOfProperties = response.data.total;
				response.data.properties.forEach(property => {
					if (property.area_label.includes('Near Boro Park')) {
						property.area_label = ['Brooklyn'];
					}

					if (property.area_label.includes('Near Brooklyn')) {
						property.area_label = ['New Jersey'];
					}

					property.property_type_label.forEach((label, i) => {
						if (label.search('Comunity') > -1) {
							label = label.replace('Comunity', 'Community');
							property.property_type_label[i] = label;
						}
					});
				});
				this.preloader = false;
				this.sortInProgress = false;
			});
		},
		SortOrder(item) {
			if (this.localOrderBy === item) {
				if (this.localOrder === 'asc') {
					this.localOrder = 'desc';
				} else {
					this.localOrder = 'asc';
				}
			} else {
				this.localOrder = 'asc';
			}
			return this.localOrder;
		},
		// getPage(page, $ref) {
		// 	const obj = {
		// 		order_by: this.localOrderBy,
		// 		order: this.localOrder,
		// 		page: page,
		// 		category: 2,
		// 		filter: this.filter
		// 	};
		// 	this.fetchNewActiveProperties(obj).then(response => {
		// 		$ref.updateDataPag(response.data);
		// 		this.from = response.data.from;
		// 		this.to = response.data.to;
		// 		this.numOfProperties = response.data.total_commercials;
		// 		this.mapMarkers = response.data.mapMarkers;
		// 		this.preloader = false;
		// 	});
		// },
		// checkPagination(data) {
		// 	this.showPagination = data.prev_page_url !== null || data.next_page_url !== null;
		// },
		initDropDowns() {
			const user = JSON.parse(localStorage.getItem('user'));
			const savedFilters = localStorage.getItem('filter-property') ? (JSON.parse(localStorage.getItem('filter-property')).user_id === user.id ? JSON.parse(localStorage.getItem('filter-property')).filter : []) : [];
			const dropFields = ['offering_types', 'areas', 'property_filter', 'listing_status', 'listing_type'];
			this.$store.dispatch('fetchDropDownOptions', { values: dropFields }).then((res) => {
				const data = res.data;
				this.DataFiltersModal.DataOfferingType.options = data.offering_types;
				this.DataFiltersModal.DataArea.options = data.areas;
				this.DataFiltersModal.DataPropertyType.options = data.property_filter;
				if (savedFilters && savedFilters.listing_status) {
					data.listing_status.forEach((list, index) => {
						if (savedFilters.listing_status.includes(list.id)) {
							data.listing_status[index].checked = true;
						}
					});
				}
				this.DataFiltersModal.DataListingStatus.lists = data.listing_status;
				if (savedFilters && savedFilters.listing_type) {
					data.listing_type.forEach((list, index) => {
						if (savedFilters.listing_type.includes(list.id)) {
							data.listing_type[index].checked = true;
						}
					});
				}
				this.DataFiltersModal.DataListingType.lists = data.listing_type;
			});
		},
		async startFiltration(filter) {
			if (this.$root.filtering || this.initialLoad || this.filtrationInProgress) return;
			this.filtrationInProgress = true;
			this.DataTable.items = [];
			this.preloader = true;
			this.filter = filter;
			this.isFilterHidden = true;
			const obj = {
				filter: filter,
				order_by: this.localOrderBy.replace('_label', ''),
				order: this.localOrder,
				page: 1,
				category: 2,
				isFilter: true
			};
			document.activeElement.blur();
			if (!this.listView) {
				try {
					const res = await this.$store.dispatch('fetchMapMarkers', obj);
					const markers = res.data.map(x => JSON.parse(x.map));
					const properties = res.data.map(x => { return { id: x.id, title: x.title }; });
					this.numOfProperties = properties.length;
					if (markers.length) {
						this.$refs.map.renderAllCommercialProperties(markers, properties);
						this.noResults = false;
					} else {
						this.noResults = true;
					}
					this.preloader = false;
					this.isFilterHidden = false;
					this.filtrationInProgress = false;
				} catch (err) {
					console.log(err);
				}
			} else {
				const res = await this.$store.dispatch('fetchCommercialProperties', obj);
				res.data.properties.forEach((property, index) => {
					let areaLabel = property.area_label;
					if (areaLabel.includes('Near Brooklyn')) {
						areaLabel = areaLabel.filter(label => label.trim() !== 'Near Brooklyn');
						areaLabel.push('New Jersey');
					}
					if (areaLabel.includes('Near Boro Park')) {
						areaLabel = areaLabel.filter(label => label.trim() !== 'Near Boro Park');
						areaLabel.push('Brooklyn');
					}
					property.area_label = areaLabel;

					property.property_type_label.forEach((label, i) => {
						if (label.search('Comunity') > -1) {
							label = label.replace('Comunity', 'Community');
							property.property_type_label[i] = label;
						}
					});
				});
				this.numOfProperties = res.data.total_commercials;
				this.preloader = false;
				this.isFilterHidden = false;
				this.filtrationInProgress = false;
			}
		},
		resetFiltration() {
			if (this.filtrationInProgress) return;
			this.filtrationInProgress = true;
			this.preloader = true;
			this.DataTable.items = [];
			this.filter = {};
			this.localOrder	= this.defaultOrder;
			this.localOrderBy = this.defaultOrderBy;
			const obj = {
				order_by: this.localOrderBy.replace('_label', ''),
				order: this.localOrder,
				page: 1,
				category: 2,
				isFilter: true
			};
			document.activeElement.blur();
			this.isFilterHidden = true;
			if (this.listView) {
				this.$store.dispatch('fetchCommercialProperties', obj, true).then(response => {
					this.isFilterHidden = false;
					// this.updatePagination(response.data);
					response.data.properties.forEach((property, index) => {
						let areaLabel = property.area_label;
						if (areaLabel.includes('Near Brooklyn')) {
							areaLabel = areaLabel.filter(label => label.trim() !== 'Near Brooklyn');
							areaLabel.push('New Jersey');
						}
						if (areaLabel.includes('Near Boro Park')) {
							areaLabel = areaLabel.filter(label => label.trim() !== 'Near Boro Park');
							areaLabel.push('Brooklyn');
						}
						property.area_label = areaLabel;

						property.property_type_label.forEach((label, i) => {
							if (label.search('Comunity') > -1) {
								label = label.replace('Comunity', 'Community');
								property.property_type_label[i] = label;
							}
						});
					});
					this.numOfProperties = response.data.total_commercials;
					this.preloader = false;
					this.isFilterHidden = false;
					this.filtrationInProgress = false;
					// this.$refs.map.renderAllCommercialProperties(response.data.mapMarkers, response.data.properties);
				});
			} else {
				this.$store.dispatch('fetchMapMarkers', obj).then((res) => {
					const markers = res.data.map(x => JSON.parse(x.map));
					const properties = res.data.map(x => { return { id: x.id, title: x.title }; });
					this.numOfProperties = properties.length;
					
					if (markers.length) {
						this.$refs.map.renderAllCommercialProperties(markers, properties);
						this.noResults = false;
					} else {
						this.noResults = true;
					}
					this.preloader = false;
					this.isFilterHidden = false;
					this.filtrationInProgress = false;
				});
			}
			this.initDropDowns();
		},
		// updatePagination(data) {
		// 	this.$refs.pagination.updateDataPag(data);
		// 	this.from = data.from;
		// 	this.to = data.to;
		// 	this.numOfProperties = data.total_commercials;
		// 	this.checkPagination(data);
		// },
		checkPermissions() {
			return check();
		}
	}
};
</script>

<style lang="scss" scoped>
.properties-listing {
	position: relative;
	margin-bottom: 40px;
	max-width: 1600px !important;
}

.properties-listing__tabs-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 30px 0;

	@include mq($md) {
		padding: 20px 0;
	}

	@include mq(480px) {
		flex-direction: column;
	}
}

.section-title--properties-listing {
	margin-bottom: 0;

	@include mq(480px) {
		margin-bottom: 20px;
		text-align: center;
	}
}

.properties-listing__tabs-button {
	display: flex;
	background-color: $white-lilac;
	padding: 2px;
	border-radius: 8px;
}

.btn-tab {
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	color: $shark;
	padding: 10px 20px;
	outline: none;
	width: 100%;
	transition: $dur $ease;
	cursor: pointer;
	background-color: $white-lilac;
	border-radius: 7px;
	border: 1px solid $white-lilac;
	position: relative;
	font-family: $font-main;
	font-weight: 500;
	font-size: 13px;
	line-height: 1.3;
	min-width: 127px;

	/deep/
	svg {
		height: 14px;
		color: $shark;
		fill: $shark;
		display: inline-block;
		margin-right: 5px;
		transition: $dur $ease;
	}

	&:focus {
		outline: none;
		box-shadow: none;
	}

	&:disabled {
		@include hover {
			background-color: $dodger-blue;
			color: $white;
		}
	}

	@include hover {
		background-color: $dodger-blue-light;
	}

	&.active {
		pointer-events: none;
		border: 0.5px solid rgba(34, 35, 38, 0.04);
		background-color: $azure-radiance;
		box-shadow: 0 3px 1px 0 rgba(53, 109, 241, 0.04);
		color: $white;

		/deep/
		svg {
			color: $white;
			fill: $white;
		}
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity .4s;
}

.fade-enter,
.fade-leave-to {
	opacity: 0;
}

.properties-listing__tabs-content {
	position: relative;
	min-height: 350px;
}

.properties-listing__tabs-inner {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	min-height: 484px;
}

.properties-listing__loader {
	min-height: 350px;
	height: 100%;
	padding: 50px 0;
}
</style>
